/**
 * DI-2-3 — TanStack Query keys of the intake's server reads.
 */
export const intakeKeys = {
  all: ["intake"] as const,
  near: (lat: string, lon: string, radiusM: number) =>
    [...intakeKeys.all, "turbines-near", lat, lon, radiusM] as const,
  /**
   * ZV-MIS-01C — `GET /api/inspection-3/v1/drop-targets` (inspection-3/v1
   * 2.8.0): the instructions opened to the version's workflow near a set.
   * `tenant` = the owner's slug of a shared node ("" = own).
   */
  dropTargets: (versionId: string, lat: string, lon: string, tenant: string) =>
    [...intakeKeys.all, "drop-targets", versionId, lat, lon, tenant] as const,
  dropTargetsAll: () => [...intakeKeys.all, "drop-targets"] as const,
  /** DI-2-12 — `GET /api/inspection-3/v1/workflows` (the tenant's list). */
  workflows: () => [...intakeKeys.all, "workflows"] as const,
  /** DI-2-9 — `intake/v1` reads, per acquisition. */
  status: (daId: string) => [...intakeKeys.all, "status", daId] as const,
  /**
   * DI-3-6 — the status read with `includeDisabled=true` (the absorbed
   * flights too). Under `status(daId)`, so every invalidation of the set's
   * status refreshes it as well.
   */
  statusWithAbsorbed: (daId: string) =>
    [...intakeKeys.status(daId), "includeDisabled"] as const,
  points: (daId: string) => [...intakeKeys.all, "points", daId] as const,
  /**
   * DI-2-5 — `listLogCandidates`. DI-4-2 (intake/v1 1.33.0) — the read
   * options ride in the key (`{includeNotRelevant}`), so the default read and
   * the "include anyway" read are two cache entries. Without options the key
   * is their common prefix: an invalidation of `candidates(daId)` refreshes
   * both.
   */
  candidates: (daId: string, opts?: { includeNotRelevant: boolean }) =>
    opts
      ? ([
          ...intakeKeys.all,
          "log-candidates",
          daId,
          { includeNotRelevant: opts.includeNotRelevant },
        ] as const)
      : ([...intakeKeys.all, "log-candidates", daId] as const),
  /** DI-2-15 — `GET /api/intake/v1/intakes` (the "My intake" page), per query. */
  intakes: (query: string) => [...intakeKeys.all, "intakes", query] as const,
  /** DI-3-C — `POST /api/intake/v1/log-check`, per position + window. */
  logCheck: (
    position: string,
    window: string,
    opts: { includeNotRelevant: boolean } = { includeNotRelevant: false },
  ) =>
    [
      ...intakeKeys.all,
      "log-check",
      position,
      window,
      // DI-4-2 — the body's flag rides in the key (decide sends `false`)
      { includeNotRelevant: opts.includeNotRelevant },
    ] as const,
  /** DI-3-C — the own projects of the intent menu. */
  ownProjects: () => [...intakeKeys.all, "own-projects"] as const,
};
